import { quantity } from "@common/util/strings";

const MAX_PLAIN_DAYS = 90;
const DAYS_IN_MONTH = 30;
const MONTHS_IN_YEAR = 12;
const DAYS_IN_YEAR = DAYS_IN_MONTH * MONTHS_IN_YEAR;

/**
 * Formats a day count, scaling the unit up so large values stay readable:
 * 45 -> "45 days", 120 -> "4mo", 400 -> "1y 1mo".
 */
export const formatDayDuration = (days: number): string => {
  const total = Number.isFinite(days) ? Math.max(0, Math.round(days)) : 0;

  if (total <= MAX_PLAIN_DAYS) {
    return `${total} ${quantity(total, "day", "days")}`;
  }

  if (total < DAYS_IN_YEAR) {
    const months = Math.floor(total / DAYS_IN_MONTH);
    const restDays = total - months * DAYS_IN_MONTH;
    return restDays ? `${months}mo ${restDays}d` : `${months}mo`;
  }

  const years = Math.floor(total / DAYS_IN_YEAR);
  const months = Math.floor((total - years * DAYS_IN_YEAR) / DAYS_IN_MONTH);
  return months ? `${years}y ${months}mo` : `${years}y`;
};
